import { useCallback, useContext, useEffect, useState } from 'react'
import update from 'immutability-helper'

import { ContextApi } from '../../context/contextApi.js';
import { DragLine } from './dragLine.jsx'

import styles from './style.module.scss';

// const transform = `translate3d(${left}px, ${top}px, 0)`

const style = {
  width: 400,
  padding: 20,
  backgroundColor: '#2B292A',
//   transform,
//   WebkitTransform: transform,
}

export const Container = ({ setShowMenuOrderingCameras, setIdRegiao, idEstado }) => {
  const { 
      getRegions, 
      allRegions, 
      ordenarRegiao 
    } = useContext(ContextApi)
    
    useEffect(() => {
      getRegions()
    }, [])

    let filterRegionsForStates = allRegions.filter(region => region.estado_sigla === idEstado)

  {
    const [cards, setCards] = useState(filterRegionsForStates)

    useEffect(() => {
        let ids;
        ids = cards.map(id => id.id)
          const idPosition = {
            ids
          }
            ordenarRegiao(idPosition)               
    }, [cards])
    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setCards((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])
    const renderCard = useCallback((card, index) => {
      return (
        <>
            <DragLine
              key={card.id}
              index={index}
              id={card.id}
              text={card.nome}
              moveCard={moveCard}
              setShowMenuOrderingCameras={setShowMenuOrderingCameras}
              setIdRegiao={setIdRegiao}
              />
        </>
      )
    }, [])
    return (
      <>
        <span className={styles.titleDragContainer}>Arraste e solte as regiões na posição desejada</span>
        <div style={style}>{cards.map((card, i) => renderCard(card, i))}</div>
      </>
    )
  }
}
